export default {
  collarDetailsList: {
    column: {
      recipientsCompanyCode: '业务公司',
      recipientsCompanyName: '业务公司名称',
      recipientsCompanyPlaceholder: '请选择公司代码',
      recipientsDepartmentCode: '业务部门',
      recipientsDepartmentName: '业务部门名称',
      recipientsDepartmentCodePlaceholder: '请选择部门代码',
      createPersonNo: '操作人',
      partnerCode: '供应商编号',
      partnerName: '供应商',
      createDateStart: '创建日期起',
      createDateEnd: '创建日期止',
      DatePlaceholder: '请选择日期',
      goodsType: '原料类别',
      selectPlaceholder: '请选择',
      productCodePlaceholder: '请选择商品编码',
      outboundDateStart: '出库开始日期',
      outboundDateEnd: '出库结束日期',
      storageCode: '出库仓库',
      receiptNo: '回单号',
      receiptNoPlaceholder: '请输入回单号',
      productCountCondition: '商品数量条件',
      productCount: '领用数量',
      productCountTotal: '领用总数量',
      productCountPlaceholder: '请输入领用数量',
      detailLabel: '明细标识',
      detailLabelPlaceholder: '请选择明细标识',
      createBy: '创建人',
      createPersonName: '操作人',
      companyCode: '公司编号',
      departmentCode: '部门编号',
      productUnit: '单位',
      sortNo: '序号',
      outboundDate: '出库日期',
      companyName: '公司',
      createDate: '创建日期',
      remark: '备注',
      subTotal: '小计',
      redBack: '红冲退回',
      productCode: '原料编码',
      productName: '原料名称',
      projectCode: '项目代码',
      projectName: '项目名称',
      productSpec: '规格型号',
      productType: '主料/辅料',
      productCategory: '原料大类',
      periodName: '账期',
    },
    message: {
      noData: '您还未选择任何数据',
      pleaseSelectOne: '请选择一条数据操作',
      topFormCheckResult: '请您将数据填写完整',
      saveSuccess: '保存成功',
      deleteSuccess: '删除成功',
      baseDataIncomplete: '请将基本数据填写完整',
      data_repeat: '已存在该数据',
      cancelled: '已取消',
      canNotChange: '该数据状态不可编辑',
      noExport: '没有数据可供导出',
      noPeriodName: '请选择账期',
    },
    placeholder: {
      goodsType: '请选择商品类别',
      productCode: '请选择商品编码',
      productName: '请选择商品名称',
      productCount: '请选择领用数量',
      productUnit: '请选择单位',
    },
    search: {
      gt: '大于',
      lt: '小于',
      notEqual: '不等于',
      equal: '等于',
    },
    form: {
      importPeriodNameSelect: '请选择导入账期',
    },
    label: {
      periodName: '请选择账期',
    },
  },
};
